import React, { useState, useCallback, useMemo, useContext,useEffect } from "react";
import { Col, Container, Row, Card, CardBody, CardHeader, Table } from "reactstrap";
import BreadCrumb from "../../../../Components/Common/BreadCrumb/BreadCrumb";
import TableContainerMin from "../../../../Components/Common/TableContainer";
import { useQuery, useQueryClient } from "react-query";
import { Avatar, Button, Modal, Spin } from "antd";
import HistoryContext from "../../../../Components/Hooks/HistoryContext";
import toast from "react-hot-toast";
import "../../../Styles/style.css"
import { getDriverById } from "../../../Drivers/services/driverApi";
import { useTranslation } from "react-i18next"; 
import avatar1 from "../../../../assets/images/users/avatar-user.png";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const UserDetail = () => {
  const history = useContext(HistoryContext);
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  document.title = `Chauffeurs | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const columns = useMemo(() => [
  ], [ ]);
  const { id } = useParams(); // Récupérer l'ID depuis l'URL
  const { data:user, isLoading, isError, error } = useQuery(['user', id], () => getDriverById(id));
  const tabs = ['Tous', 'Assignés', 'Non assignés', 'Archivés'];
  const [activeTab, setActiveTab] = useState('Tous');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'En service':
        case 'En service #2FB550':
        case 'Actif #2FB550':
        return '#2FB550';
      case 'Hors service':
        return ' #FF2D55';
      default:
        return ' #FF9500';
  
    }
  };const avatarImage= user?.fileName;
  const imageUrl = avatarImage
  ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`:avatar1;
  
  const renderTabs = () => (
    <div className="d-flex gap-3 mb-3">
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => handleTabChange(tab)}
          className={`btn ${activeTab == tab ? 'active-tab' : 'btn-light'}`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );
  const HeaderTable = () => (
    <div className="d-flex justify-content-between align-items-center w-100">
      <div style={{ position: "absolute", top: "10px", left: "20px" }}>
        <div className="d-flex gap-3 align-items-center">
          <svg
            width="40"
            height="20"
            viewBox="0 0 50 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 6L0 12L10 18"
              fill="none"
              stroke="#000000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <line
              x1="10"
              y1="12"
              x2="30"
              y2="12"
              stroke="#000000"
              strokeWidth="2"
            />
          </svg>
          <strong style={{ fontSize: "14px", marginLeft: "-30px" }}>
            {t("drivers.driver_list")}
          </strong>
          <span style={{ fontSize: "14px", marginLeft: "-10px" }}>/ {user?.name}</span>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column", 
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
    className="small-avatarVehicle"
    src={imageUrl}
    alt=""
  />
        <p style={{ fontSize: "14px", fontWeight: "bold" }}>{user?.name}</p>
        <div>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%',  backgroundColor: user?.status ? getStatusColor(user.status) : 'gray', marginRight: '8px' }}></span>
              <p style={{ fontSize: "12px" }}>{user?.status === null ? " status non disponible" : ""}  <span style={{textDecoration:'underline'}} >{user?.email}</span> </p>   
        </div>
      </div>
      <div
        style={{
          position: "absolute", 
          top: "10px", 
          right: "20px", 
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: "30px", 
          height: "30px",
          backgroundColor: "#f5f5f5", 
          borderRadius: "50%", 
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)", 
        }}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Premier point */}
          <circle cx="6" cy="12" r="2" fill="#004D47" />
          {/* Deuxième point */}
          <circle cx="12" cy="12" r="2" fill="#004D47" />
          {/* Troisième point */}
          <circle cx="18" cy="12" r="2" fill="#004D47" />
        </svg>
      </div>
    </div>
  );
 
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <Card id="contactList">
                <CardHeader>
                  <HeaderTable/>
                </CardHeader>
                <CardBody className="pt-0">
                  <TableContainerMin
                    columns={columns}
                    isGlobalSearch={true}
                    isGlobalFilter={true}
                    className="custom-header-css"
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    HeaderTable={HeaderTable}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserDetail;
